import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { agentOfficeSetupService } from "services";
import { uiActions } from "store";
import { ChangeFeeTemplateStatusProps, ErrorResponse } from "types";

const useChangeFeeTemplateStatusMutation = (onSuccess?: Function) => {
	const dispatch = useDispatch();

	return useMutation(
		({ companyId, templateId, active }: ChangeFeeTemplateStatusProps) => {
			return agentOfficeSetupService.changeFeeTemplateStatus(
				companyId,
				templateId,
				active,
			);
		},
		{
			onSuccess() {
				onSuccess?.();
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useChangeFeeTemplateStatusMutation;
